import { notification } from "antd";

notification.config({
  placement: "top",     // Yukardan gelsin
  top: 60,              // Yukarıdan 60px mesafe ile başlasın
  duration: 5,
            

});

type NotificationType = "success" | "info" | "warning" | "error" | "default";

// Uygulamanın çalışma ortamını belirle
const environment = process.env.REACT_APP_ENVIRONMENT || "development";

// Tailwind CSS sınıflarını duruma göre döndüren fonksiyon
const getClassName = (type?: NotificationType) => {
  switch (type) {
    case "success":
      return "!bg-green-500 !text-white !z-[99999]"; // Başarı rengi
    case "info":
      return "!bg-blue-500 !text-white !z-[99999]"; // Bilgi rengi
    case "warning":
      return "!bg-yellow-500 !text-black !z-[99999]"; // Uyarı rengi
    case "error":
      return "!bg-red-500  !text-white !z-[99999]"; // Hata rengi
    case "default":
      return "!bg-[#FFC502] !rounded-md !items-center !flex !text-center  !w-[700px] left-1/2 !text-black !z-[99999] "; // Varsayılan renk
    default:
      return "!bg-gray-500 !text-black !z-[99999]"; // Varsayılan renk
  }
};



// Bildirim açma fonksiyonu
export const openNotificationWithIcon = (
  type: NotificationType,
  title: string,
  message: string | JSX.Element = "",
  internalMessage: string = ""
) => {
  // Geliştirme ortamında konsola loglama
  if (environment === "development") {
    console.log(type, title, message, internalMessage);
  }

  // Bildirimin içeriği kontrol ediliyor
  if (
    (!!title && title.trim().length > 0) ||
    (typeof message === "string" && message.trim().length > 0)
  ) {
   notification.open({
  message: (
    <span className={type === "default" ? "text-black text-center items-center flex" : "text-white "}>
      {title}
    </span>
  ),
  description:
    typeof message === "string" ? (
      <span className={type === "default" ? "text-black text-center items-center flex" : "text-white"}>{message}</span>
    ) : (
      message
    ),
  className: getClassName(type),
  placement: "top",
});

  }
};
